import { ActivateStatus } from 'api/v1/account'
import MockAdapter from 'axios-mock-adapter/types'

export function mockAccountActivateStatus(mocker: MockAdapter) {
  let counter = 0
  mocker.onGet(RegExp('^/users/token/')).reply((config) => {
    counter += 1
    if (config.url?.includes('0x3498F456645270eE003441df82C718b56c0e6666')) {
      if (counter >= 2) {
        let status = 0
        if (counter >= 3) {
          status = 1
        }
        if (counter >= 5) {
          status = 2
        }
        if (counter >= 6) {
          status = 3
        }
        console.log('🚀 ~ counter:', counter)
        console.log('🚀 ~ status:', status, ActivateStatus[status])
        return [
          200,
          {
            code: 200,
            data: {
              accountId: 0,
              layer2Id: 10036,
              address: '0x3498F456645270eE003441df82C718b56c0e6666',
              layer2Address: '0x3498F456645270eE003441df82C718b56c0e6666',
              pubKey: '',
              pubKeyHash: '',
              status,
              authToken: 'YdDHziWmeyELN7ZU',
            },
            msg: null,
          },
        ]
      }
    }
    return [
      200,
      {
        code: 1003,
        data: null,
        msg: 'AUTH_USER_NOT_REGISTER',
      },
    ]
  })
}
